import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_a29e3b18 from 'nuxt_plugin_sentryserver_a29e3b18' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_48f770ec from 'nuxt_plugin_sentryclient_48f770ec' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_e362ecd8 from 'nuxt_plugin_plugin_e362ecd8' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_nuxtleaflet_80e94fd6 from 'nuxt_plugin_nuxtleaflet_80e94fd6' // Source: ./nuxt-leaflet.js (mode: 'client')
import nuxt_plugin_vuecurrencyinput_7a98c9da from 'nuxt_plugin_vuecurrencyinput_7a98c9da' // Source: ./vue-currency-input.js (mode: 'all')
import nuxt_plugin_dayjsplugin_8f12bfa6 from 'nuxt_plugin_dayjsplugin_8f12bfa6' // Source: ./dayjs-plugin.js (mode: 'all')
import nuxt_plugin_apollomodule_4efc2308 from 'nuxt_plugin_apollomodule_4efc2308' // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_workbox_cbe94868 from 'nuxt_plugin_workbox_cbe94868' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_cb3bd242 from 'nuxt_plugin_metaplugin_cb3bd242' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_c1ec875a from 'nuxt_plugin_iconplugin_c1ec875a' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_swconfig_6305947c from 'nuxt_plugin_swconfig_6305947c' // Source: ../plugins/sw-config.js (mode: 'client')
import nuxt_plugin_dayjs_66ce5f68 from 'nuxt_plugin_dayjs_66ce5f68' // Source: ../plugins/dayjs.js (mode: 'all')
import nuxt_plugin_vuematomo_4825ec29 from 'nuxt_plugin_vuematomo_4825ec29' // Source: ../plugins/vue-matomo.js (mode: 'client')
import nuxt_plugin_auth_7f7561ce from 'nuxt_plugin_auth_7f7561ce' // Source: ../plugins/auth.js (mode: 'client')
import nuxt_plugin_ssenotification_513cee2e from 'nuxt_plugin_ssenotification_513cee2e' // Source: ../plugins/sse-notification.js (mode: 'client')
import nuxt_plugin_vuetelinputvuetify_00185d1c from 'nuxt_plugin_vuetelinputvuetify_00185d1c' // Source: ../plugins/vue-tel-input-vuetify (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"aposio - prenez rendez-vous en ligne votre artisan","meta":[{"charset":"utf-8"},{"lang":"fr"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"une panne, une problème, un projet ? trouvez des professionnels et prenez rendez-vous en ligne avec un artisan proche de chez vous. lave-linge en panne ? fuite d'eau dans la salle de bain ? plus d'eau chaude ? pas de stress, libérez-vous des contraintes et prenez rendez-vous en ligne facilement avec un professionnel. proximité, fiabilité, simplicité. aposio libère votre temps ;-)"}],"link":[{"rel":"icon","type":"image\u002Fpng","href":"\u002Ffavicon_logo_aposio_512x512.png"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Lato:100,300,400,500,700,900&font-display=swap"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Montserrat:wght@100;300;400;500;700;900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_a29e3b18 === 'function') {
    await nuxt_plugin_sentryserver_a29e3b18(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_48f770ec === 'function') {
    await nuxt_plugin_sentryclient_48f770ec(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_e362ecd8 === 'function') {
    await nuxt_plugin_plugin_e362ecd8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtleaflet_80e94fd6 === 'function') {
    await nuxt_plugin_nuxtleaflet_80e94fd6(app.context, inject)
  }

  if (typeof nuxt_plugin_vuecurrencyinput_7a98c9da === 'function') {
    await nuxt_plugin_vuecurrencyinput_7a98c9da(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjsplugin_8f12bfa6 === 'function') {
    await nuxt_plugin_dayjsplugin_8f12bfa6(app.context, inject)
  }

  if (typeof nuxt_plugin_apollomodule_4efc2308 === 'function') {
    await nuxt_plugin_apollomodule_4efc2308(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_cbe94868 === 'function') {
    await nuxt_plugin_workbox_cbe94868(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_cb3bd242 === 'function') {
    await nuxt_plugin_metaplugin_cb3bd242(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_c1ec875a === 'function') {
    await nuxt_plugin_iconplugin_c1ec875a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_swconfig_6305947c === 'function') {
    await nuxt_plugin_swconfig_6305947c(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjs_66ce5f68 === 'function') {
    await nuxt_plugin_dayjs_66ce5f68(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuematomo_4825ec29 === 'function') {
    await nuxt_plugin_vuematomo_4825ec29(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_auth_7f7561ce === 'function') {
    await nuxt_plugin_auth_7f7561ce(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_ssenotification_513cee2e === 'function') {
    await nuxt_plugin_ssenotification_513cee2e(app.context, inject)
  }

  if (typeof nuxt_plugin_vuetelinputvuetify_00185d1c === 'function') {
    await nuxt_plugin_vuetelinputvuetify_00185d1c(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
